import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'

@Component({
  selector: 'app-componente-data4',
  templateUrl: './componente-data4.component.html',
  styleUrls: ['./componente-data4.component.scss']
})
export class ComponenteData4Component implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};

  dtTrigger: Subject<ComponenteData4Component> = new Subject();

  arraydeposts=[]
  nombre='';
  email='';
  password='';
  empresa='';
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''
  creandousuario=false

  botondisabled=true
  arraydeempresas=[]

  constructor(private functions: AngularFireFunctions, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.inicializadatatables(()=>{
      this.query1(()=>{
        this.dtTrigger.next();
      })
    })
    this.cargaempresas()
  }



  ngAfterViewInit(): void {
    
  }

  cargaempresas(){
    this.arraydeempresas=[];
    let query1 = firebase.firestore().collection("empresas");
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeempresas.push(doc);
      })
    })
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  actualiza(){
    this.rerender()
  }

  rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
        // Destroy the table first
        dtInstance.destroy();
        //reload your data
        this.query1(()=>{
           // Call the dtTrigger to rerender after callback
           this.dtTrigger.next();
        })
      });
  }

  query1(callback){
    this.arraydeposts=[];
    let query1 = firebase.firestore().collection("users");
    
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeposts.push(doc);
      })
    }).then(()=>{
      callback()
    }).catch((err)=>{
      console.log(err);
    })
  }

  inicializadatatables(callback) {
    this.dtOptions = {
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      "pageLength": 200,
      scrollX: false,
   
      // Configure the buttons
      buttons: [
        'colvis',
        'excel',
        // 'columnsToggle',
        'print'
      ]
    };
    callback()
  }


validaboton(){
  console.log("validaboton activado")
  if(this.email!=''&&this.nombre!=''&&this.password!=''){
    this.botondisabled=false
  }else{
    this.botondisabled=true
  }
}


//nuevo
crearUsuario(){
  this.creandousuario=true
  this.alerta("warning","Creando usuario...")

  firebase.auth().createUserWithEmailAndPassword(this.email,this.password).then((data)=>{
  
    let newUser: firebase.User = data.user;

    //con updateprofile le agregamos al objeto data las propiedades display name y photourl que no es nada en esta app
    newUser.updateProfile({
      displayName: this.nombre
    }).then(async(doc) => {
      console.log("user creado en users")
      firebase.firestore().collection("users").doc(data.user.uid).set({
        nombre:this.nombre,
        email:this.email,
        bloqueado:false,
        id:data.user.uid,
        empresa:this.empresa
      }).then(()=>{
         //mandamos mail de verificación
        let user = firebase.auth().currentUser;
         user.sendEmailVerification().then( ()=> {
            this.rerender()
            this.creandousuario=false
            this.alerta("success","¡Usuario creado con éxito! Por favor asegúrese de recordarle al usuario que debe activar su cuenta siguiendo el link que ha sido enviado a su mail")
            this.nombre=''
            this.email=''
            this.empresa=''
            this.password=''
          })


    }).catch((err)=>{
      this.alerta("danger",err)
      this.creandousuario=false
    })

    }).catch((err)=> {
      this.alerta("danger",err)
      this.creandousuario=false 
    });

    

  }).catch((err)=>{
    this.alerta("danger",err)
    this.creandousuario=false 
  });

}
//fin de nuevo





  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }



  closeAlert(){
    this.alertaActiva=false
  }


  detallesUsuario(usuario){
    const modalRef = this.modalService.open(ModalAccionesUsuarioComponent);
    modalRef.componentInstance.usuario = usuario;//pasamos al modal el parámetro de usuario
  
    //para recibir data desde el modal
    modalRef.result.then((result) => {
      if (result=="OK") {
      this.rerender()
      }
      });
  }



}//fin de clase

